const offerNames = {
  secondMonthFree: 'secondmonthfree', // used in backend (subscription/inquire)
  thirdMonthFree: 'thirdmonthfree', // used in backend (subscription/inquire)
  fiveMonthsDiscount: 'fivemonthdiscount',
  off15: '15_off',
  off25: '25_off',
  off30: '30_off',
  off50: '50_off',
  giftConnect5off: 'Giftconnect5off',
  freeHandCream: 'freeHandCream', // used in backend (subscription/inquire)
  freeLipBalm: 'freeLipBalm', // used in backend (subscription/inquire)
  freeTrial: 'freeTrial',
  off30Influencer: 'off30Influencer',
  specialCase: 'specialCase',
  freeSecondPerfume: 'freeSecondPerfume',
}


export default offerNames
